/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Select_Folder_TitleInputs */



/**
* | output |
* | --- |
* | "Batch Export - Select Folder" |
*
* @param {Explorer_Info_Batch_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_select_folder_title = /** @type {((inputs?: Explorer_Info_Batch_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation par lots - Sélectionner un dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapelexport – Ordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione in batch - Seleziona cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетный экспорт - Выберите папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación por lotes: Seleccionar carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量导出 - 选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一括エクスポート - フォルダの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच निर्यात - फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação em lote - Selecionar pasta")
	return /** @type {LocalizedString} */ ("Batch Export - Select Folder")
});